import { PREVIEW_MOCK_DATA, isPreviewMode } from '../../utils/previewMode';
import { makeGenericApiAction } from './shared/helpers';

export const fetchDietaryTagsAction = (payload) => async (dispatch) => {
  if (isPreviewMode()) {
    dispatch({ type: 'FETCH_DIETARY_TAGS_SUCCESS', payload: PREVIEW_MOCK_DATA.dietaryTags });
    return;
  }

  makeGenericApiAction({
    action: 'FETCH_DIETARY_TAGS',
    model: 'dietaryTags',
    dispatch,
    method: 'get',
    path: 'bookings/getAllDietaryTags',
    errorMessage: 'an error occurred while retrieving dietary tags.',
    payload,
    extractModel: true,
  });
};
